import { defineComponent } from "vue";
import { mapActions, mapGetters } from "vuex";

export default defineComponent({
  name: "Management",
  props: {
    beginRetraction: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    VuePagination: () => import("laravel-vue-pagination"),
  },
  computed: {
    ...mapGetters("permisosSindicalesV2License", [
      "traceabilityGetter",
      "processingTraceabilityGetter",
    ]),
    fields() {
      return [
        {
          key: "selected",
          label: "",
          sortable: false,
        },
        {
          key: "core_employee.name",
          label: "Colaborador",
          sortable: false,
        },
        {
          key: "management",
          label: "Gestión del permiso",
          sortable: false,
        },
        {
          key: "show_details",
          label: "",
          sortable: false,
        },
        {
          key: "updated_at",
          label: "Fecha y hora",
          sortable: false,
        },
      ];
    },
    id() {
      return Number(this.$route.params.id || 0);
    },
    formatUpdateAt() {
      return (date = "") => {
        return date
          ? this.$moment(date).format("DD [de] MMMM [de] YYYY [-] h:m A")
          : "Pendiente";
      };
    },
    formatStateManagement() {
      return ({ status, user }) => {
        const name = user ? user.name : null;
        const role = name && user.core_role ? user.core_role.name : null;
        const list = {
          approved: user
            ? `Aprobado por ${name} (${role})`
            : "Aprobación automatica",
          pending: "Pendiente",
          rejected: `Rechazado por ${name} (${role})`,
          retraction: "Retractación del permiso",
        };
        return list[status] ? list[status] : "<Sin Estado>";
      };
    },
    separateAudits() {
      return ({ audits, is_automatic_approval, status, updated_at }) => {
        const [first_, ...others] = audits;
        const responseUpdateAt =
          status === "approved" && is_automatic_approval
            ? updated_at
            : first_
            ? first_.updated_at
            : updated_at;
        const response = { status, updated_at: responseUpdateAt };
        return {
          first: is_automatic_approval ? response : first_ || response,
          others,
        };
      };
    },
  },
  // , async beforeMount () {
  //     await this.getTraceabilityAction({ id: this.id })
  // }
  watch: {
    beginRetraction() {
      if (this.beginRetraction === false)
        this.$refs.tableManagement.clearSelected();
    },
  },
  methods: {
    ...mapActions("permisosSindicalesV2License", ["getTraceabilityAction"]),
    async changePage(page = 1) {
      await this.getTraceabilityAction({ id: this.id, data: { page } });
    },
    onRowSelected(items) {
      this.$emit("selected:collaborator", items);
    },
  },
});
